<template>
  <div class="slotmodal">
    <h3>{{$t('front.gnb.slotgame')}}<img class="close" src="@/assets/img/icon_cancel.png" @click="$emit('isSlot')" /></h3>
    <div class="search-wrap">
      <input type="text" v-model="searchTerm" @keyup.enter="filterList" placeholder="검색어를 입력하세요." />
    </div>
    <div class="slotmodalwrap">
        <p v-if="isLoading" class="slot-list-state" role="status">게임 목록을 불러오는 중입니다.</p>
        <p v-else-if="filteredList.length === 0" class="slot-list-state" role="status">표시할 게임이 없습니다.</p>
        <ul>
          <template v-for="(item, index) in filteredList" v-bind:key="index">
             <template v-for="subItem in item" v-bind:key="subItem.id">
               <li>
                 <a @click="setSlotGame(subItem)">
                   <img :src="subItem.image" />
                   <span class="sname">{{subItem.names.ko}}</span>
                 </a>
               </li>
             </template>
          </template>
        </ul>
    </div>
  </div>
</template>

<script>
import { getGameSlotList } from '@/api/game'
import { mapState } from 'vuex'

export default {
  name: 'SlotList',
  props: [
    'groupCode',
    'codeName',
    'code'
  ],
  data () {
    return {
      list: [],
      isLoading: true,
      searchTerm: ''
    }
  },
  created () {
    if (this.groupCode && this.codeName) {
      this.loadSlotList()
    }
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    filteredList () {
      if (!this.searchTerm) {
        return this.list
      }
      return this.list.map(subList =>
        subList.filter(subItem => subItem.names.ko.includes(this.searchTerm))
      ).filter(subList => subList.length > 0)
    }
  },
  watch: {
    codeName () {
      if (this.groupCode && this.codeName) {
        this.loadSlotList()
      }
    }
  },
  methods: {
    async setSlotGame (item) {
      const gameKey = item.key
      const codeInfo = this.code ? this.commonCodeByCode[this.code] : this.commonCode[this.groupCode][this.codeName]
      const params = {
        vendorKey: codeInfo.code.toString(),
        gameType: codeInfo.groupCode.toString(),
        gameKey: gameKey
      }
      if (this.userData) {
        if (codeInfo.codeName.indexOf('H-') > -1) {
          // hotel
          await this.onSlotSelectGame(params)
        } else {
          await this.onGetGame(params)
        }
      } else {
        await this.onCheck('front.error.afterSignin')
      }
    },
    async loadSlotList () {
      this.list = []
      this.isLoading = true
      this.emitter.emit('Loading', true)
      try {
        const params = await this.onSelectGame(this.groupCode, this.codeName)
        if (!params) return

        if (this.codeName.indexOf('H-') > -1) {
          this.list.push([
            {
              category: 'slot',
              key: 'SLOT01',
              image: require('@/assets/img/game_h-slot_pc_1.jpg')
            },
            {
              category: 'slot',
              key: 'SLOT02',
              image: require('@/assets/img/game_h-slot_pc_2.jpg')
            }
          ])
        } else {
          const response = await getGameSlotList(params)
          const result = response.data
          if (result.resultCode === '0') {
            const list = Array.isArray(result.data?.games) ? result.data.games : []
            for (let i = 0; i < list.length; i += 4) {
              this.list.push(list.slice(i, i + 4))
            }
          } else {
            await this.onAlert('warningart', result.resultMessage || '게임 목록을 불러오지 못했습니다.', 'check', null, true)
          }
        }
      } catch (error) {
        await this.onCheck('게임 목록을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.')
      } finally {
        this.isLoading = false
        this.emitter.emit('Loading', false)
      }
    }
  }
}
</script>

<style scoped>
.slot-list-state {padding: 32px;text-align: center;color: #666;}
.slotmodalwrap::-webkit-scrollbar {width: 10px;}
.slotmodalwrap::-webkit-scrollbar-thumb {background-color: none;border-radius: 10px;background-clip: padding-box;border: 2px solid transparent;}
.slotmodalwrap::-webkit-scrollbar-track {background-color: none;border-radius: 10px;}
.slotmodal {background: #fff;border: 1px solid #ddd;border-radius: 30px;position: fixed;left: 50%;top: 50%; transform: translate(-50%,-50%);z-index: 100;width: 1314px;}
.slotmodal>h3 {width: 100%;position: relative;text-align: center;font-size: 30px;font-weight: bold;color: #444;padding: 15px 0;background: #f2f2f2;border-radius: 30px 30px 0 0;}
.slotmodal>h3 .close {position: absolute;right: 15px;top: 9px;height: 40px;filter: invert(1);cursor: pointer;}
.slotmodalwrap {max-height: 680px;min-height: 680px;overflow-y: auto;padding-top: 30px;min-width: 320px;}
.slotmodalwrap ul {padding: 0 30px 30px;display: flex;gap: 20px;justify-content: center;flex-direction: row;flex-wrap: wrap;}
.slotmodalwrap ul li {transition: all ease 1s;cursor: pointer;flex: auto;max-width: 190px;}
.slotmodalwrap ul li:hover, .slotmodal ul li:focus, .slotmodal ul li:active {transform: scale(1.02);}
.slotmodalwrap ul li img {width: 100%;border-radius: 12px;height: 160px;object-fit: cover;object-position: center;box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.16);}
.sname {font-size: 16px;color: #444;margin-top: 5px;line-height: 1.2em;display: flex;align-items: center;justify-content: center;}
.search-wrap {padding: 30px 30px 0;}
.search-wrap input {width: 100%;height: 40px;padding-left: 30px;border: 2px solid #ddd; box-sizing: border-box;border-radius: 6px;background: #f2f2f2;color: #444;}
</style>
<style>
@media (min-width: 1px) and (max-width: 1314px){
   .slotmodal {width: 100% !important;height: 100%;}
   .slotmodalwrap {max-height: calc(100% - 70px) !important;}
}
@media (min-width: 1px) and (max-width: 800px){
   .slotmodalwrap ul {padding: 0 0 30px !important;}
}
@media (min-width: 1px) and (max-width: 450px){
   .slotmodalwrap ul li {width: calc(50% - 11px);}
}
</style>
